import React, { Component } from 'react';
import hoistStatics from 'hoist-non-react-statics';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import throttle from 'lodash/throttle';

function throttleProps(wait, options = {}) {
  return (ThrottledComponent) => {
    /* TODO - update to new safe React16 lifecycle methods upon upgrade */
    class ThrottleWrapper extends Component {
      constructor(props) {
        super(props);
        this.state = {};
        this.throttledSetState = throttle(
          (nextState) => this.setState(nextState),
          wait,
          options
        );
      }

      // eslint-disable-next-line react/no-deprecated -- directive added automatically by Shepherd migration
      componentWillMount() {
        this.throttledSetState({ props: this.props });
      }

      // eslint-disable-next-line react/no-deprecated -- directive added automatically by Shepherd migration
      componentWillReceiveProps(nextProps) {
        this.throttledSetState({ props: nextProps });
      }

      shouldComponentUpdate(nextProps, nextState) {
        return this.state !== nextState;
      }

      componentWillUnmount() {
        this.throttledSetState.cancel();
      }

      render() {
        return <ThrottledComponent {...this.state.props} />;
      }
    }

    // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
    ThrottleWrapper.displayName =
      ThrottledComponent.displayName || ThrottledComponent.name;
    // expose child methods on parent
    return hoistStatics(ThrottleWrapper, ThrottledComponent);
  };
}

export default throttleProps;
